import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    emoji: '🎉',
    title: 'BONO 1 — 52 Planes Mágicos',
    desc: 'Una idea nueva cada semana del año. Nunca más un fin de semana vacío.',
    value: '$5'
  }, {
    num: '02',
    emoji: '🗝️',
    title: 'BONO 2 — Juegos para descubrir lo que siente',
    desc: 'Conversaciones profundas disfrazadas de juego. Abrís mundos sin que parezca una charla seria.',
    value: '$5'
  }, {
    num: '03',
    emoji: '💌',
    title: 'BONO 3 — 30 cosas que quiero que nunca olvides',
    desc: 'Frases y actividades para dejar una huella emocional imborrable en tus hijos.',
    value: '$5'
  }, {
    num: '04',
    emoji: '👵',
    title: 'BONO 4 — Abuelita, cuéntame tu historia',
    desc: 'Para que los abuelos compartan sus recuerdos y sabiduría con toda la familia.',
    value: '$5'
  }, {
    num: '05',
    emoji: '👴',
    title: 'BONO 5 — Abuelito, cuéntame tu historia',
    desc: 'Para que los abuelos compartan sus vivencias y enseñanzas antes de que sea tarde.',
    value: '$5'
  }, {
    num: '06',
    emoji: '👩',
    title: 'BONO 6 — Mamá, cuéntame tu historia',
    desc: 'Un espacio para que mamá comparta su vida, sus sueños y sus aprendizajes.',
    value: '$5'
  }, {
    num: '07',
    emoji: '👨',
    title: 'BONO 7 — Papá, cuéntame tu historia',
    desc: 'Un espacio para que papá deje su historia escrita para siempre.',
    value: '$5'
  }];
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative overflow-hidden" data-id="element-20">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-purple-900/10 via-navy-950 to-navy-950 pointer-events-none hidden md:block" data-id="element-21" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-23">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/20 text-gold-400 mb-6 shadow-[0_0_20px_rgba(234,179,8,0.2)]" data-id="element-24">
            <Gift className="w-8 h-8" data-id="element-25" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-26">
            <span data-id="element-27">🎁</span> 7 BONOS EXCLUSIVOS
          </h2>
          <div className="inline-block bg-gradient-to-r from-gold-600/20 to-yellow-500/20 border border-gold-500/30 text-gold-300 font-bold px-6 py-2 rounded-full text-lg tracking-widest uppercase" data-id="element-28">
            SOLO POR ACCEDER HOY
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-29">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className="bg-navy-900 border border-navy-700 rounded-3xl p-5 md:p-6 relative overflow-hidden group hover:border-gold-500/40 transition-colors" data-id="element-30">
              <div className="absolute -right-4 -top-4 text-6xl md:text-8xl font-black text-navy-800/50 group-hover:text-navy-800 transition-colors" data-id="element-31">
                {bonus.num}
              </div>

              <div className="relative z-10" data-id="element-32">
                <div className="text-3xl mb-4" data-id="element-33">{bonus.emoji}</div>
                <h3 className="text-xl font-bold text-white mb-3 pr-8" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-slate-400 text-sm mb-6 min-h-[80px]" data-id="element-35">
                  {bonus.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-navy-800" data-id="element-36">
                  <span className="text-slate-500 line-through text-sm" data-id="element-37">
                    {bonus.value}
                  </span>
                  <span className="bg-green-500/20 text-green-400 font-bold px-3 py-1 rounded text-sm" data-id="element-38">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.3
      }} className="bg-gradient-to-r from-gold-600/10 via-gold-500/10 to-gold-600/10 border border-gold-500/30 rounded-3xl p-8 text-center max-w-3xl mx-auto glow-gold" data-id="element-39">
          <p className="text-xl md:text-2xl font-medium text-slate-300" data-id="element-40">
            Valor total bonos{' '}
            <span className="line-through text-slate-500 mx-2" data-id="element-41">$35</span>
            <span className="text-gold-400 font-bold block md:inline mt-2 md:mt-0" data-id="element-42">
              → Incluidos GRATIS con tu Pack hoy
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}